import {AnyAction} from 'redux';
import {ReducerState} from './utils';
import FrameActionType from './FrameActionType';

/**
 * Stav frame.
 */
export interface FrameState extends ReducerState<FrameState> {
    /**
     * Zda je pozastaveno odebírání z fronty zpráv.
     */
    postSuspended: boolean;

    /**
     * Fronta zpráv.
     */
    messages: any[];
}

/**
 * Výchozí stav frame.
 *
 * @ignore
 */
const initialState: FrameState = {
    reducer: FrameReducer,
    postSuspended: false,
    messages: [],
};

/**
 * Reducer stavu frame.
 *
 * @param state - Aktuální stav.
 * @param action - Akce.
 * @returns Nový stav.
 */
export default function FrameReducer(state: FrameState = initialState, action?: AnyAction): FrameState {
    if (!action) {
        return state;
    }

    switch (action.type) {
        case FrameActionType.SET_POST_SUSPENDED:
            return {
                ...state,
                postSuspended: action.suspended,
            };

        case FrameActionType.POST_MESSAGE:
            return {
                ...state,
                messages: [...state.messages, action.message],
            };

        case FrameActionType.CLEAR_MESSAGES: {
            return {
                ...state,
                messages: [],
            };
        }

        default:
            return state;
    }
}
